import {
  CircularProgress,
  Container,
  Divider,
  Tooltip,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Grid } from "@mui/material";
import DownloadLogo from "assets/img/download.png";
import ExcelLogo from "assets/img/excel-logo.png";
import axios from "axios";
import {
  ArrayChip,
  AutoCompleteWithSearch,
  ButtonGroupTop,
  CustomTable,
  ImportDocumentModal,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SearchTextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

function Lagu({ userLogin }) {
  const classes = globalStyles();
  const history = useHistory();
  const location = useLocation();
  const roleType = userLogin.role.type;
  const isAssociation = roleType === "association";
  const roleAssociation = roleType === "association";
  const selectPublisher = roleAssociation || roleType === "society";
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsSearch = urlParams?.get("search");
  const paramsPage = urlParams?.get("page");
  const paramsSize = urlParams?.get("size");
  const paramsComposer = urlParams?.get("composer_id");
  const paramsSort = urlParams?.get("sort");

  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [modalDocument, setModalDocument] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    search: paramsSearch || "",
    original_publisher_id: "",
    sort: paramsSort || "",
    composer_id: paramsComposer || "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [searchComposer, setSearchComposer] = useState("");
  const [searchPublisher, setSearchPublisher] = useState("");
  const [optionComposer, setOptionComposer] = useState([]);
  const [optionPublisher, setOptionPublisher] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [selectedPublisherId, setSelectedPublisherId] = useState(null);
  const [societyFormat, setSocietyFormat] = useState("asaba");

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };
  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const params = {
        ...queryParams,
      };
      const res = await axios.get(`${hardBaseUrl}/songs`, {
        headers,
        params,
      });

      const { data, meta } = res?.data;
      setDataTable(data);
      const pageCount = getTotalPage(meta?.total, queryParams?.size || 1);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const getOptionComposer = async () => {
    try {
      setLoadingFilter(true);
      const res = await axios.get(`${hardBaseUrl}/composers`, {
        headers,
        params: {
          page: 1,
          size: 50,
          ...(searchComposer && { search: searchComposer }),
        },
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.composer_id,
        label: item?.sure_name,
      }));
      setOptionComposer(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingFilter(false);
    }
  };

  const getOptionPublisher = async () => {
    try {
      setLoadingFilter(true);
      const res = await axios.get(`${hardBaseUrl}/publisher`, {
        headers,
        params: {
          page: 1,
          size: 50,
          ...(searchPublisher && { search: searchPublisher }),
        },
      });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.publisher_id,
        label: item?.name,
      }));
      setOptionPublisher(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingFilter(false);
    }
  };

  const debounceOptionComposer = useCallback(
    debounce(() => {
      getOptionComposer();
    }, 500),
    [searchComposer]
  );
  const handleDelete = async id => {
    try {
      setLoadingPage(true);
      await axios.delete(`${hardBaseUrl}/songs/${id}`, {
        headers,
      });
      ModalSuccess("Succesfully delete song").then(() => getDataTable());
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const handleDownloadDocument = async () => {
    try {
      setLoadingButton(true);

      // Siapkan params dasar
      const params = {};

      // Hanya masukkan publisher_id ke params jika role-nya association
      if (roleType === "association" && queryParams?.publisher_id) {
        params.publisher_id = queryParams.publisher_id;
      }

      const res = await axios.get(
        `${hardBaseUrl}/publisher/song/export/${queryParams?.composer_id || 0}`,
        {
          headers,
          params, // Gunakan params yang sudah divalidasi
        }
      );
      ModalSuccess(res.data?.message);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
    }
  };
  const handleUploadDocument = async documentFiles => {
    const formData = new FormData();
    formData.append("files", documentFiles[0]);
    formData.append("format", societyFormat);
    if (societyFormat === "asaba") {
      formData.append("publisher_id", selectedPublisherId);
    }
    try {
      setLoadingButton(true);
      await axios.post(`${hardBaseUrl}/publisher/song/import`, formData, {
        headers,
      });
      ModalSuccess(
        "You can check the progress of the upload process in the Upload Monitoring Menu",
        "Data is being processed"
      ).then(() => {
        getDataTable();
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
      setModalDocument(false);
    }
  };

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);
  useEffect(() => {
    debounceOptionComposer();
    return () => {
      debounceOptionComposer.cancel();
    };
  }, [searchComposer, debounceOptionComposer]);
  useEffect(() => {
    getOptionPublisher();
  }, []);

  return (
    <Page className={classes.root} title="Song">
      <Container maxWidth={false}>
        <HeaderTitle title="Parameter" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid container justifyContent="space-between" rowGap={1} my="16px">
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <Grid container columnSpacing={1} alignItems="center">
              <Grid item>
                <AutoCompleteWithSearch
                  label="Composer/Author"
                  options={optionComposer}
                  optionLabel="sure_name"
                  loading={loadingFilter}
                  inputValue={searchComposer}
                  onInputChange={setSearchComposer}
                  value={
                    optionComposer?.find(
                      option => option?.composer_id === queryParams?.composer_id
                    ) || null
                  }
                  onChange={item =>
                    handleChangeQueryParams(item?.composer_id, "composer_id")
                  }
                  disabled={loadingPage}
                />
              </Grid>
              {isAssociation && (
                <Grid item>
                  <AutoCompleteWithSearch
                    label="Publisher"
                    options={optionPublisher}
                    optionLabel="name"
                    loading={loadingFilter}
                    inputValue={searchPublisher}
                    onInputChange={setSearchPublisher}
                    value={
                      optionPublisher?.find(
                        option =>
                          option?.publisher_id === queryParams?.publisher_id
                      ) || null
                    }
                    onChange={item =>
                      handleChangeQueryParams(
                        item?.publisher_id,
                        "publisher_id"
                      )
                    }
                    disabled={loadingPage}
                  />
                </Grid>
              )}

              <Tooltip title="Download Document">
                <Grid item>
                  <PrimaryButton
                    onClick={handleDownloadDocument}
                    disabled={loadingButton || loadingPage}
                    label={
                      loadingButton ? (
                        <CircularProgress size="24px" color="inherit" />
                      ) : (
                        <img src={DownloadLogo} alt="logo" />
                      )
                    }
                    height="42px"
                  />
                </Grid>
              </Tooltip>
              <Tooltip title="Import Document">
                <Grid item>
                  <PrimaryButton
                    onClick={() => setModalDocument(true)}
                    label={<img src={ExcelLogo} alt="logo" />}
                    height="42px"
                    color="#34774C"
                    disabled={loadingPage}
                  />
                </Grid>
              </Tooltip>
              <Grid item>
                <PrimaryButton
                  label="Add Song"
                  onClick={() => history.push("/admin/parameter/lagu/tambah")}
                  startIcon={<AddIcon />}
                  size="large"
                  disabled={loadingPage}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable({ roleAssociation })}
          data={dataTable || []}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          sortValue={queryParams?.sort}
          onRequestSort={sortBy => {
            handleChangeQueryParams(
              `${sortBy} ${
                queryParams.sort === `${sortBy} asc` ? "desc" : "asc"
              }`,
              "sort"
            );
          }}
          isHaveAction
          deleteConfirmation
          deleteConfirmationContent={item =>
            `Are you sure you want to delete song ${item?.title_song} ?`
          }
          handleDelete={item => handleDelete(item?.song_id)}
          handleEdit={item =>
            history.push(`/admin/parameter/lagu/edit/${item?.song_id}`)
          }
        />
      </Container>
      {modalDocument && (
        <ImportDocumentModal
          open={modalDocument}
          onClose={() => setModalDocument(false)}
          onSubmit={handleUploadDocument}
          fileType=".xlsx, .xls"
          loadingButton={loadingButton}
          downloadFile
          roleType={roleType}
          onChangePublisher={
            selectPublisher ? value => setSelectedPublisherId(value) : null
          }
          onChangeFormat={
            societyFormat ? value => setSocietyFormat(value) : null
          }
        />
      )}
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Parameter",
    link: "/admin/parameter/lagu",
  },
  {
    label: "Song",
    active: true,
  },
];
const columnTable = ({ roleAssociation }) => [
  {
    name: "title_song",
    title: "Song Title",
    useSort: true,
    sort_key: "song_title",
    renderText: item => item || "-",
  },
  {
    name: "song_aliases",
    title: "Alias Song Title",
    renderText: item => <ArrayChip list={item} />,
  },
  {
    name: "publisher_name",
    title: "Publisher",
    sort_key: "publisher_name",
    useSort: true,
  },
  {
    name: "original_publisher_name",
    title: "Original Publisher",
    sort_key: "original_publisher_name",
    useSort: true,
  },
  {
    name: "iswc_code",
    title: "ISWC",
    sort_key: "iswc_code",
    useSort: true,
  },
  {
    name: "all",
    title: "Composer/Author",
    renderText: item => (
      <ArrayChip
        list={
          roleAssociation
            ? item?.composer_names
            : item?.song_composer?.map(
                composer => composer?.composer?.sure_name
              )
        }
        max={5}
      />
    ),
  },
  {
    name: roleAssociation ? "composer_aliases" : "song_composer",
    title: "Composer Alias Name",
    renderText: item => {
      const getAlias = item?.reduce(
        (current, next) => [...current, ...(next?.alias_names?.flat() || [])],
        []
      );
      return <ArrayChip list={roleAssociation ? item : getAlias} max={3} />;
    },
  },
];
export default Lagu;
